import { render, staticRenderFns } from "./tagsearch.vue?vue&type=template&id=b9722dd6&scoped=true&"
import script from "./tagsearch.vue?vue&type=script&lang=js&"
export * from "./tagsearch.vue?vue&type=script&lang=js&"
import style0 from "./tagsearch.vue?vue&type=style&index=0&id=b9722dd6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9722dd6",
  null
  
)

export default component.exports